import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const sliceReducer = createSlice({
  name: 'intelligence/objectives',
  initialState,
  reducers: {},
});

export default sliceReducer;
